import {
    Dashboard as DashboardIcon,
    SendSharp,
    EmailSharp,
    People,
    Logout,
    ArrowBack,
    EventNote,
    Payments,
    MonitorHeart,
    CloudQueue,
} from "@mui/icons-material";
import { MdWhatsapp as MdWhatsappIcon } from "react-icons/md";

export const ADMIN_BASE_PATH = "/admin/vspp/9403/ktl/dashboard";

export const ADMIN_NAV_ITEMS = [
    {
        id: "overview",
        label: "Overview",
        path: ADMIN_BASE_PATH,
        icon: <DashboardIcon sx={{ fontSize: 22 }} />,
        end: true,
    },
    {
        id: "personal",
        label: "Personal WhatsApp",
        path: `${ADMIN_BASE_PATH}/personal`,
        icon: <SendSharp sx={{ fontSize: 22 }} />,
        description: "Manage Personal WA users and PWC credits",
    },
    {
        id: "email",
        label: "Business Email",
        path: `${ADMIN_BASE_PATH}/email`,
        icon: <EmailSharp sx={{ fontSize: 22 }} />,
        description: "Manage email users, workers, domains & BEC credits",
    },
    {
        id: "aws-ses-accounts",
        label: "AWS SES accounts",
        path: `${ADMIN_BASE_PATH}/aws-ses-accounts`,
        icon: <CloudQueue sx={{ fontSize: 22 }} />,
        description: "Manage AWS SES credentials for domain verification",
    },
    {
        id: "whatsapp-business",
        label: "WhatsApp Business",
        path: `${ADMIN_BASE_PATH}/whatsapp-business`,
        icon: <MdWhatsappIcon size={22} />,
        description: "Manage WB users, agents & BWC credits",
    },
    {
        id: "all-users",
        label: "All users",
        path: `${ADMIN_BASE_PATH}/all-users`,
        icon: <People sx={{ fontSize: 22 }} />,
        description: "Full directory across all services",
    },
    {
        id: "subscriptions",
        label: "Subscriptions",
        path: `${ADMIN_BASE_PATH}/subscriptions`,
        icon: <EventNote sx={{ fontSize: 22 }} />,
        description: "Subscription end dates across services",
    },
    {
        id: "credit-rates",
        label: "Credit rates",
        path: `${ADMIN_BASE_PATH}/credit-rates`,
        icon: <Payments sx={{ fontSize: 22 }} />,
        description: "Prices for the credit wallet",
    },
    {
        id: "service-health",
        label: "Service health",
        path: `${ADMIN_BASE_PATH}/service-health`,
        icon: <MonitorHeart sx={{ fontSize: 22 }} />,
        description: "Script heartbeat monitoring",
    },
];

export const ADMIN_FOOTER_ITEMS = [
    {
        id: "back-to-app",
        label: "Back to app",
        path: "/dashboard",
        icon: <ArrowBack sx={{ fontSize: 22 }} />,
    },
    {
        id: "logout",
        label: "Logout",
        action: "logout",
        icon: <Logout sx={{ fontSize: 22 }} />,
    },
];
